import React from 'react';
import styles from './ui.module.css';

interface SkeletonProps {
  /** CSS width — a number is px. Defaults to the full line. */
  width?: number | string;
  /** CSS height — a number is px. Defaults to one line of text. */
  height?: number | string;
  /** 'circle' for avatars/dots; 'block' for icons, bars and tiles. */
  shape?: 'text' | 'block' | 'circle';
  className?: string;
  style?: React.CSSProperties;
}

/**
 * A shimmering stand-in for content that is still loading. Size it like the
 * thing it replaces so the layout does not jump when the data lands. Purely
 * decorative — the region that holds it should carry `aria-busy`.
 */
const Skeleton: React.FC<SkeletonProps> = ({ width, height, shape = 'text', className, style }) => (
  <span
    aria-hidden="true"
    className={`${styles.skeleton} ${shape === 'circle' ? styles.skeletonCircle : shape === 'block' ? styles.skeletonBlock : ''}${className ? ` ${className}` : ''}`}
    style={{ width, height, ...style }}
  />
);

export default Skeleton;
